module.exports = __webpack_public_path__ + "44c10a592ef2abf2538b5a037f6917a2.woff";